/* Hypnotic Villas — Premium Winter Edition · interactions
   snow (canvas), parallax, 3D tilt, reveal, kinetic text, rail, lightbox, tabs, header, lang, newsletter */
(function () {
  'use strict';
  const doc = document;
  const rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const $ = (s, c) => (c || doc).querySelector(s);
  const $$ = (s, c) => Array.from((c || doc).querySelectorAll(s));

  /* ---------- Header: glass on scroll, hide on scroll-down ---------- */
  const header = $('.hv-header');
  if (header) {
    let last = 0, ticking = false;
    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 40);
      if (!header.classList.contains('is-locked')) {
        header.classList.toggle('is-hidden', y > 320 && y > last + 4);
        if (y < last - 4) header.classList.remove('is-hidden');
      }
      last = y; ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(onScroll); ticking = true; } }, { passive: true });
    onScroll();
    const burger = $('.hv-burger'), drawer = $('.hv-drawer');
    if (burger && drawer) {
      const toggle = (open) => {
        burger.setAttribute('aria-expanded', open);
        drawer.classList.toggle('is-open', open);
        header.classList.toggle('is-locked', open);
        header.classList.remove('is-hidden');
        doc.documentElement.style.overflow = open ? 'hidden' : '';
      };
      burger.addEventListener('click', () => toggle(burger.getAttribute('aria-expanded') !== 'true'));
      $$('a', drawer).forEach(a => a.addEventListener('click', () => toggle(false)));
      doc.addEventListener('keydown', e => { if (e.key === 'Escape') toggle(false); });
    }
  }

  /* ---------- Language switcher (Shopify localization form) ---------- */
  $$('.hv-lang').forEach(box => {
    const form = $('form', box);
    const input = form && $('input[name="locale_code"]', form);
    $$('button[data-locale]', box).forEach(b => b.addEventListener('click', () => {
      if (input) { input.value = b.dataset.locale; form.submit(); }
    }));
    doc.addEventListener('click', e => { if (!box.contains(e.target)) box.removeAttribute('open'); });
  });

  /* ---------- Reveal on scroll ---------- */
  const io = new IntersectionObserver((entries) => {
    entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
  $$('.hv-reveal, .hv-words, .hv-intro__statement').forEach(el => io.observe(el));

  /* ---------- Kinetic headline: split words ---------- */
  $$('.hv-words').forEach(el => {
    if (el.dataset.split) return; el.dataset.split = '1';
    const walk = (node) => {
      Array.from(node.childNodes).forEach(n => {
        if (n.nodeType === 3) {
          const frag = doc.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(part => {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(doc.createTextNode(' ')); return; }
            const w = doc.createElement('span'); w.className = 'w';
            const s = doc.createElement('span'); s.textContent = part; w.appendChild(s); frag.appendChild(w);
          });
          node.replaceChild(frag, n);
        } else if (n.nodeType === 1) walk(n);
      });
    };
    walk(el);
    $$('.w > span', el).forEach((s, i) => s.style.setProperty('--i', i));
  });
  $$('.hv-intro__statement').forEach(el => {
    if (el.dataset.split) return; el.dataset.split = '1';
    const html = el.innerHTML.split(/<br\s*\/?>/i);
    el.innerHTML = html.map((h, i) => `<span class="hv-line"><span style="--i:${i}">${h.trim()}</span></span>`).join('');
  });

  /* ---------- Parallax (hero video / villa hero / intro frames) ---------- */
  if (!rm) {
    const items = $$('[data-parallax]');
    if (items.length) {
      let raf = false;
      const run = () => {
        const vh = window.innerHeight;
        items.forEach(el => {
          const r = el.getBoundingClientRect();
          if (r.bottom < 0 || r.top > vh) return;
          const p = (r.top + r.height / 2 - vh / 2) / vh; // -1..1
          const amt = parseFloat(el.dataset.parallax) || 12;
          el.style.transform = `translate3d(0, ${p * amt}%, 0) scale(${1 + Math.abs(amt) / 100 + 0.02})`;
        });
        raf = false;
      };
      window.addEventListener('scroll', () => { if (!raf) { requestAnimationFrame(run); raf = true; } }, { passive: true });
      run();
    }
  }

  /* ---------- 3D tilt cards ---------- */
  if (fine && !rm) {
    $$('[data-tilt]').forEach(card => {
      const max = parseFloat(card.dataset.tilt) || 6;
      card.addEventListener('pointermove', e => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        card.style.setProperty('--ry', ((x - .5) * max * 2).toFixed(2) + 'deg');
        card.style.setProperty('--rx', ((.5 - y) * max * 2).toFixed(2) + 'deg');
        card.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
        card.style.setProperty('--my', (y * 100).toFixed(1) + '%');
      });
      card.addEventListener('pointerleave', () => { card.style.setProperty('--rx', '0deg'); card.style.setProperty('--ry', '0deg'); });
    });
    // subtle 3D float for the glass quick-book card following the mouse
    const q = $('.hv-quick');
    if (q) {
      window.addEventListener('pointermove', e => {
        const x = e.clientX / window.innerWidth - .5, y = e.clientY / window.innerHeight - .5;
        q.style.transform = `perspective(1400px) rotateY(${x * 5}deg) rotateX(${-y * 5}deg) translateZ(0)`;
      }, { passive: true });
    }
  }

  /* ---------- Snow (2D canvas, GPU-friendly, depth layers) ---------- */
  $$('canvas[data-snow]').forEach(canvas => {
    if (rm) { canvas.remove(); return; }
    const ctx = canvas.getContext('2d', { alpha: true });
    const density = parseFloat(canvas.dataset.snow) || 1;
    let w, h, flakes = [], run = true, dpr = Math.min(window.devicePixelRatio || 1, 2);
    const wind = { x: 0, t: 0 };
    const resize = () => {
      const r = canvas.parentElement.getBoundingClientRect();
      w = canvas.width = Math.floor(r.width * dpr); h = canvas.height = Math.floor(r.height * dpr);
      canvas.style.width = r.width + 'px'; canvas.style.height = r.height + 'px';
      const n = Math.min(260, Math.floor((r.width * r.height) / 9000 * density));
      flakes = Array.from({ length: n }, () => mk(true));
    };
    const mk = (init) => {
      const z = Math.random(); // depth
      return { x: Math.random() * w, y: init ? Math.random() * h : -10 * dpr, z,
        r: (0.6 + z * 2.2) * dpr, vy: (0.25 + z * 0.9) * dpr, vx: (Math.random() - .5) * .3 * dpr,
        a: 0.25 + z * 0.55, p: Math.random() * Math.PI * 2, s: 0.6 + Math.random() * 1.2 };
    };
    const draw = () => {
      if (!run) return;
      ctx.clearRect(0, 0, w, h);
      wind.t += 0.003; wind.x = Math.sin(wind.t) * 0.35 * dpr;
      for (const f of flakes) {
        f.p += 0.012 * f.s;
        f.x += f.vx + wind.x * f.z + Math.sin(f.p) * 0.25 * dpr;
        f.y += f.vy;
        if (f.y > h + 10 || f.x < -10 || f.x > w + 10) Object.assign(f, mk(false));
        ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(244,241,232,${f.a})`; ctx.fill();
      }
      requestAnimationFrame(draw);
    };
    resize(); draw();
    window.addEventListener('resize', resize);
    new IntersectionObserver(en => { run = en[0].isIntersecting; if (run) draw(); }, { threshold: 0 }).observe(canvas);
  });

  /* ---------- Steam / fog blobs for SPA section ---------- */
  $$('canvas[data-steam]').forEach(canvas => {
    if (rm) { canvas.remove(); return; }
    const ctx = canvas.getContext('2d'); let w, h, run = true, t = 0;
    const blobs = Array.from({ length: 7 }, (_, i) => ({ x: Math.random(), y: .6 + Math.random() * .5, r: .25 + Math.random() * .3, s: .0006 + Math.random() * .0008, o: i }));
    const resize = () => { const r = canvas.parentElement.getBoundingClientRect(); w = canvas.width = r.width / 2; h = canvas.height = r.height / 2; canvas.style.width = r.width + 'px'; canvas.style.height = r.height + 'px'; };
    const draw = () => {
      if (!run) return; t++;
      ctx.clearRect(0, 0, w, h);
      blobs.forEach(b => {
        b.y -= b.s; if (b.y < -0.4) b.y = 1.3;
        const x = (b.x + Math.sin(t * .004 + b.o) * .05) * w, y = b.y * h, r = b.r * w;
        const g = ctx.createRadialGradient(x, y, 0, x, y, r);
        g.addColorStop(0, 'rgba(244,241,232,0.10)'); g.addColorStop(1, 'rgba(244,241,232,0)');
        ctx.fillStyle = g; ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.fill();
      });
      requestAnimationFrame(draw);
    };
    resize(); draw(); window.addEventListener('resize', resize);
    new IntersectionObserver(en => { run = en[0].isIntersecting; if (run) draw(); }).observe(canvas);
  });

  /* ---------- Lazy videos: play only when visible ---------- */
  $$('video[data-lazy]').forEach(v => {
    const load = () => { $$('source', v).forEach(s => { if (s.dataset.src) { s.src = s.dataset.src; delete s.dataset.src; } }); v.load(); };
    new IntersectionObserver(en => {
      if (en[0].isIntersecting) { if (!v.dataset.loaded) { load(); v.dataset.loaded = 1; } v.play().catch(() => {}); }
      else v.pause();
    }, { rootMargin: '200px' }).observe(v);
  });

  /* ---------- Count-up stats ---------- */
  $$('[data-count]').forEach(el => {
    const target = parseFloat(el.dataset.count), dec = (el.dataset.count.split('.')[1] || '').length;
    new IntersectionObserver((en, o) => {
      if (!en[0].isIntersecting) return; o.disconnect();
      if (rm) { el.textContent = el.dataset.count; return; }
      const t0 = performance.now(), dur = 1400;
      const step = (now) => { const p = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - p, 3); el.textContent = (target * e).toFixed(dec); if (p < 1) requestAnimationFrame(step); };
      requestAnimationFrame(step);
    }, { threshold: .6 }).observe(el);
  });

  /* ---------- Horizontal rail: drag + buttons ---------- */
  $$('.hv-rail').forEach(rail => {
    let down = false, sx = 0, sl = 0, moved = false;
    rail.addEventListener('pointerdown', e => { if (!fine) return; down = true; moved = false; sx = e.clientX; sl = rail.scrollLeft; rail.classList.add('is-drag'); });
    window.addEventListener('pointermove', e => { if (!down) return; const dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true; rail.scrollLeft = sl - dx; });
    window.addEventListener('pointerup', () => { if (!down) return; down = false; rail.classList.remove('is-drag'); });
    rail.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    const wrap = rail.closest('section') || rail.parentElement;
    $$('[data-rail-prev], [data-rail-next]', wrap).forEach(b => b.addEventListener('click', () => {
      const card = $('.hv-card', rail); const step = card ? card.getBoundingClientRect().width + 20 : 320;
      rail.scrollBy({ left: b.hasAttribute('data-rail-next') ? step : -step, behavior: 'smooth' });
    }));
  });

  /* ---------- Lightbox ---------- */
  const lbLinks = $$('[data-lightbox]');
  if (lbLinks.length) {
    const lb = doc.createElement('div'); lb.className = 'hv-lightbox';
    lb.innerHTML = '<button class="hv-lightbox__close" aria-label="Close">×</button><button class="hv-lightbox__btn hv-lightbox__prev" aria-label="Previous"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M15 5l-7 7 7 7"/></svg></button><img alt=""><button class="hv-lightbox__btn hv-lightbox__next" aria-label="Next"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M9 5l7 7-7 7"/></svg></button><div class="hv-lightbox__count"></div>';
    doc.body.appendChild(lb);
    const img = $('img', lb), count = $('.hv-lightbox__count', lb);
    let group = [], idx = 0;
    const show = (i) => { idx = (i + group.length) % group.length; img.src = group[idx].href; img.alt = group[idx].dataset.alt || ''; count.textContent = (idx + 1) + ' / ' + group.length; };
    const open = (a) => { group = lbLinks.filter(x => x.dataset.lightbox === a.dataset.lightbox); show(group.indexOf(a)); lb.classList.add('is-open'); doc.documentElement.style.overflow = 'hidden'; };
    const close = () => { lb.classList.remove('is-open'); doc.documentElement.style.overflow = ''; };
    lbLinks.forEach(a => a.addEventListener('click', e => { e.preventDefault(); open(a); }));
    $('.hv-lightbox__close', lb).addEventListener('click', close);
    $('.hv-lightbox__prev', lb).addEventListener('click', () => show(idx - 1));
    $('.hv-lightbox__next', lb).addEventListener('click', () => show(idx + 1));
    lb.addEventListener('click', e => { if (e.target === lb) close(); });
    doc.addEventListener('keydown', e => { if (!lb.classList.contains('is-open')) return; if (e.key === 'Escape') close(); if (e.key === 'ArrowRight') show(idx + 1); if (e.key === 'ArrowLeft') show(idx - 1); });
    let tx = 0; lb.addEventListener('touchstart', e => tx = e.touches[0].clientX, { passive: true });
    lb.addEventListener('touchend', e => { const dx = e.changedTouches[0].clientX - tx; if (Math.abs(dx) > 50) show(idx + (dx < 0 ? 1 : -1)); });
  }

  /* ---------- Tabs (villa page) ---------- */
  $$('.hv-vtabs').forEach(tabs => {
    const btns = $$('button', tabs);
    btns.forEach(b => b.addEventListener('click', () => {
      btns.forEach(x => x.setAttribute('aria-selected', x === b));
      $$('.hv-vpanel', tabs.parentElement).forEach(p => p.classList.toggle('is-active', p.id === b.getAttribute('aria-controls')));
    }));
  });

  /* ---------- Smooth anchor to booking panel ---------- */
  $$('a[href="#hv-booking"], a[href="#book"]').forEach(a => a.addEventListener('click', e => {
    const t = $('#hv-booking') || $('#book'); if (!t) return; e.preventDefault();
    const y = t.getBoundingClientRect().top + window.scrollY - 90; window.scrollTo({ top: y, behavior: rm ? 'auto' : 'smooth' });
  }));

  /* ---------- Newsletter: ajax submit, stay on page ---------- */
  $$('form.hv-news__form').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = $('button', form), ok = form.parentElement.querySelector('.hv-news__ok');
      btn.disabled = true;
      try { await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest' } }); } catch (_) {}
      form.hidden = true; if (ok) ok.hidden = false;
    });
  });

  /* ---------- Cursor glow (desktop only, very light) ---------- */
  if (fine && !rm) {
    const glow = doc.createElement('div');
    // Скрит, докато мишката не се движи по страницата; без mix-blend-mode (в Safari оставяше „прозрачен квадрат“ в ъгъла)
    glow.className = 'hv-cursor-glow';
    glow.style.cssText = 'position:fixed;left:0;top:0;width:520px;height:520px;border-radius:50%;pointer-events:none;z-index:0;background:radial-gradient(circle,rgba(201,163,102,.06) 0%,rgba(201,163,102,0) 60%);opacity:0;transition:opacity .5s;will-change:transform;';
    doc.body.appendChild(glow);
    let gx = -1000, gy = -1000, cx = -1000, cy = -1000, live = false;
    window.addEventListener('pointermove', e => { if (!live) { live = true; cx = e.clientX; cy = e.clientY; glow.style.opacity = '1'; } gx = e.clientX; gy = e.clientY; }, { passive: true });
    doc.addEventListener('mouseleave', () => { glow.style.opacity = '0'; });
    doc.addEventListener('mouseenter', () => { if (live) glow.style.opacity = '1'; });
    const loop = () => { if (live) { cx += (gx - cx) * .08; cy += (gy - cy) * .08; glow.style.transform = `translate(${cx - 260}px, ${cy - 260}px)`; } requestAnimationFrame(loop); };
    loop();
  }
})();